import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AdobeLaunchService } from 'src/app/adobe-launch/adobe-launch.service';
import { constants } from 'src/app/constants/constants';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { WindowRefService } from 'src/app/shared/services/window-ref/window-ref.service';
import { content } from 'src/assets/content/fallback-content';
import { environment } from 'src/environments/environment';

export type FeedbackState = 'positive' | 'negative' | null;

@Component({
  selector: 'redesign-feedback-survey',
  imports: [CommonModule],
  templateUrl: './redesign-feedback-survey.html',
  styleUrl: './redesign-feedback-survey.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RedesignFeedbackSurvey {
  private readonly formId = environment.MEDALLIA_REDESIGN_SURVEY_ID;
  redesignSurveyContent = content.Data.v4_rcc_root.content.redesignSurvey;
  constants = constants;

  constructor(
    private readonly contentService: ContentService,
    private readonly windowRefService: WindowRefService,
    private readonly adobeLaunchService: AdobeLaunchService,
  ) {
    this.contentService.getContent().subscribe((data) => {
      this.redesignSurveyContent = data.Data.v4_rcc_root.content.redesignSurvey;
    });
  }

  openSurvey(): void {
    if (this.feedbackState === 'positive') {
      this.adobeLaunchService.captureCtaLink('feedback:worked-well-for-you');
    } else if (this.feedbackState === 'negative') {
      this.adobeLaunchService.captureCtaLink('feedback:tell-us-more');
    }
    this.windowRefService.getWindow().KAMPYLE_ONSITE_SDK?.showForm(this.formId);
  }

  feedbackState: FeedbackState = null;

  onThumbUp(): void {
    this.feedbackState = 'positive';
    this.adobeLaunchService.captureCtaButton('feedback:thumbs-up');
  }

  onThumbDown(): void {
    this.feedbackState = 'negative';
    this.adobeLaunchService.captureCtaButton('feedback:thumbs-down');
  }
}
